import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=12736ec6"
import script from "./BannerComponent.vue?vue&type=script&lang=js"
export * from "./BannerComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerComponent.vue?vue&type=style&index=0&id=12736ec6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports